<template>
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m286.462-358.463-32.615-32.614L480-617.23l226.153 225.537-32.615 32.615L480-552.616 286.462-358.463Z"/></svg>
</template>
